import { useMemo } from "react";
import { useStore } from "react-redux";

const Lieferadresse = (props) => {
  const { adressennummer, name } = props || {};
  const { basketStorage } = useStore().getState();

  const item = useMemo(() => {
    return basketStorage.filialen.find(f => Number(f.value) === Number(adressennummer)) || {};
  }, [adressennummer, basketStorage.filialen]);

  return item.address ? item.address : name || "";
};

export default Lieferadresse;
